module.exports = __webpack_public_path__ + "img/icon_radar-mode-off.ef84e2eb.svg";